module Elma.Bindings {

    /**
     * Interface for SlideToVisible
     */
    export interface ISlideToVisibleParams {
        observable: KnockoutObservable<boolean>;
    }

    /**
     * SlideToVisible - CustomBinding
     * Slides an element into a visible state
     * Examlpe usage: http://screencast.com/t/vgyiR2Gs
     */
    export class SlideToVisible {

        /**
         * Initialization of the binding, runns on load.
         * @param element <HTMLElement> - the element to whoom the binding is bound.
         * @param valueAccessor <KnockoutObservable<boolean>> - the value of the observable, the type is defined by the interface. Used to get the value from the observable by wrapping the observable in the valueAccessor fn.
         * @param allBindingsAccessor <KnockoutAllBindingsAccessor> - Knockout object that helps get the observable value through any binding - i think
         * @param viewModel <any> - the viewmodel in which the element is placed
         * @param bindingContext <KnockoutBindingContext> - not really sure what this does
         */
        public init(element: HTMLElement, valueAccessor: () => ISlideToVisibleParams, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;
            console.log("init");
        }

        /**
         * Updating the binding when the observable value is changed. This is kinda like a subscription, or an specific eventListener.
         * @param element <HTMLElement> - the element to whoom the binding is bound.
         * @param valueAccessor <KnockoutObservable<boolean>> - the value of the observable, the type is defined by the interface. Used to get the value from the observable by wrapping the observable in the valueAccessor fn.
         * @param allBindingsAccessor <KnockoutAllBindingsAccessor> - Knockout object that helps get the observable value through any binding - i think
         * @param viewModel <any> - the viewmodel in which the element is placed
         * @param bindingContext <KnockoutBindingContext> - not really sure what this does
         */
        public update(element: HTMLElement, valueAccessor: () => ISlideToVisibleParams, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext) 
                return;

            var $element = $(element); // Unnesscary, if we want the element as pojo, but needed if we need jQ elm
            console.log($element);
            var value = valueAccessor(); // Accessing the value of the observable, which is defined in the interface. In this specific case the value is provided by the click binding (ToggleClickBinding)
            console.log(value);
            var $dwGeneratedElement = $element.next('p');
            $dwGeneratedElement.toggleClass('white-space-normal'); //$element.toggle(ko.unwrap(value)); // Use "unwrapObservable" so we can handle values that may or may not be observable
        }

    }
    // ! first letter in the bindingHandlers must be lowercase string, but only the first, so not the class initialization
    ko.bindingHandlers['slideToVisible'] = new SlideToVisible();
}